/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const noticeRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '公示公告',
        path: 'notice',
        component: () => import('@/views/notice/List'),
      },
      {
        name: '面积公示表',
        path: 'notice/area',
        component: () => import('@/views/notice/AreaPublicity'),
      },
      {
        name: '搬迁公告文件',
        path: 'notice/notice',
        component: () => import('@/views/notice/Notice'),
      },
      {
        name: '城中村相关文件',
        path: 'notice/village',
        component: () => import('@/views/notice/VillagesInCities'),
      },
      {
        name: '政策文件',
        path: 'notice/policy',
        component: () => import('@/views/notice/Policy'),
      },
    ],
  }
  
  export default noticeRouter